import type { IScheduledEmail } from '@/types/email.types';

export interface ScheduledEmailsState {
  emails: IScheduledEmail[] | null;
  loadingEmails: boolean;
  errorLoadingEmails: boolean;
  activeEmail: IScheduledEmail | null;
  loadingActiveEmail: boolean;
  errorLoadingActiveEmail: boolean;
  updatingEmail: boolean;
  errorUpdatingEmail: boolean;
  creatingEmail: boolean;
  errorCreatingEmail: boolean;
  deletingEmailUuid: string | null;
  errorDeletingEmail: boolean;
}

export const initialState: ScheduledEmailsState = {
  emails: null,
  loadingEmails: false,
  errorLoadingEmails: false,
  activeEmail: null,
  loadingActiveEmail: false,
  errorLoadingActiveEmail: false,
  creatingEmail: false,
  errorCreatingEmail: false,
  updatingEmail: false,
  errorUpdatingEmail: false,
  deletingEmailUuid: null,
  errorDeletingEmail: false,
};
